import React, { useRef, useState } from "react";
import { Form, ProgressBar, Spinner } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import CustomRadioButton from "../../../../../../../components/CustomRadioButton";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  usePostProductPriceOptionsMutation,
  useUpdateProductPriceOptionsMutation,
} from "../../../../../../../rtk-query/slices/createProduct/ProductScheduleAndPricing/productScheduleAndPricingSlice";
import Select, { components } from "react-select";
import { generateTypes } from "../../../../../../../helpers/numberOfUsers";
import { Icon } from "@iconify/react/dist/iconify.js";

// Validation schema for Formik
const validationSchema = Yup.object().shape({
  optionName: Yup.string().required("Option name is required"),
  // number: Yup.number()
  //   .required("Maximum number of travelers is required")
  //   .min(1, "Number must be greater than 0"),
});

const ScheduleTitleUpdateModal = ({
  productDetail,
  schedule,
  handleClose,
  productId,
}) => {
  const navigate = useNavigate();
  const formikRef = useRef(null); // Create a reference to Formik
  const [updateProductPriceOptions, { isLoading }] =
    useUpdateProductPriceOptionsMutation();
  const [selected, setSelected] = useState(
    schedule?.product_option_type || null
  );
  const types = generateTypes({
    selectedType: selected,
    limit: productDetail?.daily_max_capacity_shared,
  });

  const initialValues = {
    optionName: schedule?.product_option_title || "",
    priceType: schedule?.product_option_type || null,
    number: schedule?.product_option_max_capacity_per_booking
      ? {
        value: schedule?.product_option_max_capacity_per_booking,
        label: schedule?.product_option_max_capacity_per_booking,
      }
      : { value: 1, label: 1 },
  };

  // Handle key press to restrict input
  const handleKeyDown = (event) => {
    if (["e", "E", "+", "-", "."].includes(event.key) || event.key === " ") {
      event.preventDefault();
    }
  };
  return (
    <>
      <div className="cs-ps-modal-header">
        <div className="row">
          <div className="col-md-9">
            <p className="cp-ps-form-heading">
              Let's start with how you price your product
            </p>
            <p className="cp-ps-note">
              This would be your model of pricing with an offer
            </p>
          </div>
        </div>
      </div>

      <Formik
        innerRef={formikRef} // Pass the reference to Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={async (values) => {
          try {
            const formData = new FormData();
            formData.append("product_id", productId);
            formData.append(
              "option_id",
              schedule?.product_price_schedules[0]?.product_option_id
            );
            formData.append("option_title", values.optionName);
            formData.append(
              "max_capacity_per_booking",
              parseInt(values.number.value)
            );
            const lang = localStorage.getItem("productLanguage") ? localStorage.getItem("productLanguage") : "en"
            const response = await updateProductPriceOptions({ data: formData, lang: lang });

            if (response?.data?.status) {
              toast.success(response?.data?.message, {
                position: "top-center",
                autoClose: 3000,
              });

              handleClose();
              // setStepOneData(null);
            }
            if (response?.error) {
              const errors = response?.error?.data?.errors;
              if (response?.error?.status === 401) {
                localStorage.removeItem("DODLoginToken");
                toast.error(response?.error?.data?.message, {
                  position: "top-center",
                  autoClose: 3000,
                });
                navigate("/login");
              } else if (errors) {
                for (const field in errors) {
                  if (errors.hasOwnProperty(field)) {
                    // const combinedErrors = errors[field].join(" ");
                    // if (field === "supplier_type") {
                    //   setFieldError("option", combinedErrors);
                    // }
                  }
                }
                toast.error(response?.error?.data?.message, {
                  position: "top-center",
                  autoClose: 3000,
                });
              } else {
                toast.error(response?.error?.data?.message, {
                  position: "top-center",
                  autoClose: 3000,
                });
              }
            }
          } catch (error) { }
        }}
      >
        {({ setFieldValue, values }) => (
          <FormikForm className="cp-ps-form">
            <Form.Group controlId="optionName" className="cp-ps-form-group">
              <Form.Label className="cp-ps-form-label">Option name</Form.Label>
              <Field
                name="optionName"
                as={Form.Control}
                type="text"
                placeholder="Dune buggy dubai"
                className="ob-pi-input mt-1"
              />
              <ErrorMessage
                name="optionName"
                component="div"
                className="text-danger mt-2"
              />
            </Form.Group>

            <Form.Group className="cp-ps-form-group mt-4">
              <Form.Label className="cp-ps-form-label">
                How do you price your product?
              </Form.Label>
              <div className="cp-pc-meet-radio-group gap-1">
                <CustomRadioButton
                  label="By person"
                  isSelected={selected === 1}
                  onClick={() => {
                    return;
                  }}
                />
                <CustomRadioButton
                  label="By vehicle/group"
                  isSelected={selected === 2}
                  onClick={() => {
                    return;
                  }}
                />
              </div>
              <ErrorMessage
                name="priceType"
                component="div"
                className="text-danger mt-2"
              />
            </Form.Group>

            <Form.Group className="mt-3 ">
              <Form.Label className="cp-ps-form-label">
                What is the maximum number of travelers per booking?
              </Form.Label>
              <Select
                name="number"
                options={types}
                className="p-0 form-control cp-ps-timeslot-select ms-0"
                value={values.number}
                onChange={(option) => {
                  setFieldValue("number", option);
                }}
                components={{
                  Control: ({ children, ...props }) => (
                    <components.Control {...props}>
                      {children}
                      <div className="select-icon">
                        <Icon icon="ic:baseline-keyboard-arrow-down" />
                      </div>
                    </components.Control>
                  ),
                }}
              />
              <ErrorMessage
                name="number"
                component="div"
                className="text-danger mt-2"
              />
            </Form.Group>
          </FormikForm>
        )}
      </Formik>
      <div className="w-100 d-flex align-items-center justify-content-center">
        <button
          type="submit"
          className="submit-btn"
          onClick={() => formikRef?.current?.handleSubmit()}
        >
          {!isLoading ? (
            "Save"
          ) : (
            <>
              Save <Spinner size="sm" />
            </>
          )}
        </button>
      </div>
    </>
  );
};

export default ScheduleTitleUpdateModal;
